import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import {useDispatch} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL } from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { tipoDeMedio } from 'constantes/globalsStates';
import { functions } from 'constantes';

const AgregarDisponibilidad = ({title, openFullScreenDialog, handleClose, medioDeComunicacion, validarTipoDeTarifario, accionRegistroGuardado, cerrarModalPorError}) => {
    const dispatch = useDispatch();
    const [catalogoDeEspaciosPorAsignar] = useState('catalogoDeEspaciosPorAsignar');
    const [responseData, setResponseData] = useState({ errorType: 'error', messageType: '', openResponse: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);

    useEffect(() => {
        showListForm();
    },[])

    const showListForm = async () => {
        setcargandoSolicitud(true);

        const copiaDeCampos = Object.assign({}, camposDelFormulario)

        let esTercero = "";
        if(tipoDeMedio[medioDeComunicacion.tipoDelMedio] === 3) esTercero = "catalogoDeEscritos"
        else esTercero = Number(medioDeComunicacion?.canalDeTercero) === 1 ? 1 : 0;

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: catalogoDeEspaciosPorAsignar, saveInStore: false, nombreDelMetodo: "listar", parametro: esTercero}));

        setcargandoSolicitud(false);

        if(respuesta?.error) return setResponseData({ errorType: 'error', messageType: `Ocurrió un incoveniente, intente de nuevo!.`, openResponse: true, });
        if(respuesta?.data?.length === 0) return setResponseData({ errorType: 'error', messageType: `Sin datos del catalogo de espacios por asignar!.`, openResponse: true, });

        const listadoFormateado = respuesta.data?.map( ({id, espacios}) => ({id, name: espacios}) );

        copiaDeCampos.cantidadDisponible.list = functions.ordenarArreglo(listadoFormateado, 'id')
        setCamposDelFormulario(copiaDeCampos);
    }

    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
        tituloDisponibilidad:{
            idelement: "tituloDisponibilidad", title:'Disponibilidad', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloDisponibilidad", value: "", isError:false,
        },
        alertaDisponibilidad:{
            idelement: "alertaDisponibilidad", mensaje:'LA DISPONIBILIDAD MINIMA SOLICITADA ES DE 160 SPOTS DE 20 SEGUNDOS POR CADA DÍA DISPONIBLE.', elementType:'alerta', showAlertForm: true, name: "alertaDisponibilidad", value: "", isError:false, severity: 'error'
        },
        fechaDesde: {
            idelement: "fechaDesde", value: new Date(), label: "DESDE: *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false, width: '30%', minDate: new Date()
        },
        fechaHasta: {
            idelement: "fechaHasta", value: new Date(), label: "HASTA *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$",
            validators: ['required'], errorMessages:['fecha dd/MM/yyyy'], isError:false, elementType:'fecha' , disabled: false, width: '30%', minDate: new Date()
        },
        cantidadDisponible: {
            idelement: "cantidadDisponible", value: null , label: "Cantidad por día disponible *", pattern:"^[1-9][0-9]*$", validators: ['required'],
            errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '30%', marginTop: '1%'
        },
        acciones: {
            idelement: "acciones", title:'Acciones', position:"center", elementType:'titulo', showTitleForm: true, name: "acciones", value: "", isError:false,
        },
    });

    const guardarDatos = async (datosDelFormulario) => {
        setcargandoSolicitud(true);

        const { fechaDesde, fechaHasta, cantidadDisponible } = datosDelFormulario;

        const controllerMedio = validarTipoDeTarifario();

        const datosAEnviar = {
            controller: controllerMedio, action: "crear",
            data: {
                "cantidadDisponible": Number(cantidadDisponible?.name),
                "fechaFinal": functions.formatearFechaDD_MM_YYYY(fechaHasta),
                "fechaInicial": functions.formatearFechaDD_MM_YYYY(fechaDesde)
            },
            nombreDelMetodo: `crear/disponibilidad/${medioDeComunicacion?.id || ""}`
        };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));

        setcargandoSolicitud(false);
        if(respuesta?.error) return cerrarModalPorError(respuesta)

        accionRegistroGuardado(respuesta?.data)
    }

    const [listaDeBotones]= React.useState({
        "guardarDatos":{"label":"Guardar datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (errorType, messageType, openResponse = false) => setResponseData({errorType,messageType,openResponse,})
    const { errorType, messageType, openResponse} = responseData;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            maxWidth="md"
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={errorType} content={messageType} open={openResponse} handClose={handClose}/>
                <Card>
                    <CardContent>
                        <Formulario
                            elements={camposDelFormulario}
                            buttonList={listaDeBotones}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default AgregarDisponibilidad;